import styled from '@emotion/styled'

export const Icon = styled.i`
  color: transparent;
`
